// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget[data-v-3cedd1f6]{width:100%;height:100%;background-color:#fff;border:none;padding-top:10px}", ""]);
// Exports
module.exports = exports;
